"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MeasurementOverview = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const Header_1 = require("./Header");
const Body_1 = require("./Body");
const with_collapse_1 = require("../../molecules/with-collapse");
exports.MeasurementOverview = (0, react_1.memo)(({ tagVariant, tagDate, measurement, isOpen, isCollapsible, onHeaderClick }) => {
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: isCollapsible ? ((0, jsx_runtime_1.jsx)(StyledWithCollapse, { isOpen: isOpen, header: (0, jsx_runtime_1.jsx)(Header_1.Header, { onClick: onHeaderClick, tagVariant: tagVariant, tagDate: tagDate }, void 0), body: (0, jsx_runtime_1.jsx)(Body_1.Body, { measurement: measurement }, void 0) }, void 0)) : ((0, jsx_runtime_1.jsxs)(Wrapper, { children: [(0, jsx_runtime_1.jsx)(Header_1.Header, { onClick: onHeaderClick, tagVariant: tagVariant, tagDate: tagDate }, void 0), (0, jsx_runtime_1.jsx)(Body_1.Body, { measurement: measurement }, void 0)] }, void 0)) }, void 0));
});
const Wrapper = styled_components_1.default.div `
  background-color: ${({ theme }) => theme.colors.whiteBase};
  border: 1px solid ${({ theme }) => theme.colors.silverBase};
  border-radius: ${({ theme }) => theme.utils.radius};
  h2,
  p {
    margin-bottom: 0;
  }

  & > div {
    padding: ${({ theme }) => `${theme.spacings.m} ${theme.spacings.l}`};
  }
`;
const StyledWithCollapse = (0, styled_components_1.default)(with_collapse_1.WithCollapse) `
  @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
    & > div:first-of-type {
      padding: ${({ theme }) => theme.spacings.m};
    }
  }
`;
//# sourceMappingURL=index.js.map